import NodePlaylistManager from './ui';

export default NodePlaylistManager;